import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Shirditopunecab() {



    const cardData = {





keyword: "Shirdi to Pune Cabs",

headingDescription: "Sai Shirdi Cab provides comfortable and reliable Shirdi to Pune Cabs for devotees, families, tourists, senior citizens, students, and business travelers traveling from Shirdi to Pune. Customers can book private chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, and other suitable vehicles for one-way journeys, round trips, airport transfers, railway station drops, hotel transfers, business travel, family visits, and customized multi-day trips. The direct cab service offers convenient door-to-door transportation without changing vehicles, making it practical for passengers carrying luggage or traveling with children and senior citizens. With experienced drivers, clean and well-maintained vehicles, comfortable seating, sufficient luggage space, flexible pickup timings, and convenient destination drops across Pune, Sai Shirdi Cab makes the journey easier to organize. Travelers can also customize their trip to include popular Pune attractions or nearby destinations when required.",

topPlaces: [
{
title: "Pune",
description: "Pune is the main destination for this route and is a major educational, technology, business, and cultural city in Maharashtra. Travelers from Shirdi can book a private cab for direct hotel, residence, office, railway station, or airport transfers. One-way and round-trip services are suitable for families, professionals, and groups."
},
{
title: "Swargate",
description: "Swargate is a major transportation and commercial area in Pune and is a convenient destination for travelers arriving from Shirdi. Customers can arrange a private cab directly to residences, hotels, offices, or nearby transport points. Door-to-door service is particularly useful for families carrying luggage."
},
{
title: "Pune Airport",
description: "Pune Airport is an important travel hub for passengers connecting Pune with other cities. Travelers from Shirdi can book a private cab for scheduled airport drops according to their flight timings. Comfortable vehicles with sufficient luggage space are suitable for families, business travelers, and groups."
},
{
title: "Pune Railway Station",
description: "Pune Railway Station is a major rail connectivity point and is frequently used by travelers continuing their journey to other cities. Passengers from Shirdi can schedule a private cab according to their train departure time. Direct transportation provides convenience for senior citizens and families traveling with luggage."
},
{
title: "Shivajinagar",
description: "Shivajinagar is a central Pune locality with offices, educational institutions, commercial areas, and transportation facilities. Travelers from Shirdi can book private cabs for business meetings, family visits, hotel transfers, and railway connections. Flexible pickup and drop arrangements make travel convenient."
},
{
title: "Hinjewadi",
description: "Hinjewadi is one of Pune's major technology and business hubs and attracts professionals from across Maharashtra. Travelers from Shirdi can book a private cab for office visits, employee travel, business meetings, and corporate requirements. Comfortable vehicles are suitable for individuals and small groups."
},
{
title: "Kharadi",
description: "Kharadi is an important IT and commercial area in Pune with numerous offices, business parks, hotels, and residential communities. Customers traveling from Shirdi can arrange direct cab transportation for work or personal requirements. Private vehicles provide a convenient option for professionals carrying luggage or equipment."
},
{
title: "Kothrud",
description: "Kothrud is a well-established residential and commercial area in western Pune and can be a convenient destination for families traveling from Shirdi. Customers can book a private cab for direct home, hotel, or office drops. Flexible one-way and round-trip options are available according to travel requirements."
},
{
title: "Kalyani Nagar",
description: "Kalyani Nagar is a prominent Pune locality with hotels, restaurants, offices, and residential developments. Travelers from Shirdi can arrange a private cab directly to their preferred destination in the area. The service is suitable for business travelers, families, and visitors carrying luggage."
},
{
title: "Viman Nagar",
description: "Viman Nagar is a popular Pune locality located close to the airport and is known for hotels, offices, shopping areas, and residential communities. Travelers from Shirdi can book a private cab for convenient door-to-door transportation. It is particularly useful for airport-connected travel and business visits."
},
{
title: "Lonavala",
description: "Lonavala is a popular hill destination near Pune and can be added to a Shirdi to Pune journey for travelers planning a leisure trip. Visitors can explore scenic viewpoints, valleys, lakes, and waterfalls as part of an extended itinerary. Private cab service provides flexibility for sightseeing and return travel."
},
{
title: "Alandi",
description: "Alandi is an important spiritual destination near Pune associated with Sant Dnyaneshwar Maharaj. Devotees traveling from Shirdi can include Alandi in a customized pilgrimage itinerary before or after reaching Pune. Private cab transportation provides convenient travel for families and religious groups."
}
],











"services": [
{
"name": "Shirdi to Pune Cabs",
"description": "Shirdi to Pune Cabs provide convenient private transportation for passengers traveling from Shirdi to Pune. Travelers can choose a suitable vehicle according to passenger count, luggage requirements, pickup location, travel schedule, and one-way or return journey needs."
},
{
"name": "Shirdi to Pune Cab",
"description": "Shirdi to Pune Cab offers a comfortable private travel option for individuals, families, and groups traveling toward Pune. Cab arrangements can be planned according to the preferred pickup point, travel date, passenger requirements, vehicle category, and destination."
},
{
"name": "Shirdi to Pune Taxi",
"description": "Shirdi to Pune Taxi provides point-to-point private transportation for passengers planning a journey between Shirdi and Pune. Customers can select a suitable taxi based on passenger capacity, luggage space, pickup timing, travel preferences, and one-way or round-trip requirements."
},
{
"name": "Shirdi to Pune Cab Service",
"description": "Shirdi to Pune Cab Service is suitable for travelers looking for private transportation between Shirdi and Pune. The service can be arranged for family trips, pilgrimage travel, airport transfers, business journeys, and other requirements with suitable vehicle options."
},
{
"name": "Shirdi to Pune Taxi Service",
"description": "Shirdi to Pune Taxi Service provides convenient intercity transportation for passengers traveling from Shirdi to Pune. Travelers can plan their journey with an appropriate taxi according to passenger count, luggage, pickup location, travel timing, and preferred trip type."
},
{
"name": "Shirdi to Pune Cab Booking",
"description": "Shirdi to Pune Cab Booking allows passengers to reserve private transportation in advance for their journey to Pune. Customers can provide travel dates, pickup details, passenger count, luggage requirements, preferred vehicle category, and one-way or return trip preferences."
},
{
"name": "Shirdi to Pune Taxi Booking",
"description": "Shirdi to Pune Taxi Booking provides a convenient way to arrange private taxi transportation for a scheduled Pune journey. The booking can be organized according to the required pickup point, travel time, passenger requirements, vehicle type, and destination."
},
{
"name": "Shirdi to Pune Taxi Fare",
"description": "Shirdi to Pune Taxi Fare may vary according to the selected vehicle, journey type, route, passenger count, and additional travel requirements. Travelers can request a suitable fare option for one-way, round-trip, airport transfer, or customized transportation arrangements."
},
{
"name": "Shirdi to Pune Cab Fare",
"description": "Shirdi to Pune Cab Fare depends on factors such as vehicle category, trip type, pickup location, passenger capacity, and travel itinerary. Customers can choose an appropriate cab according to their comfort preferences, budget, luggage requirements, and journey plans."
},
{
"name": "Shirdi to Pune One Way Taxi",
"description": "Shirdi to Pune One Way Taxi provides direct private transportation for passengers who do not require a return journey. The taxi can be arranged from the preferred pickup point in Shirdi to the selected destination in Pune."
},
{
"name": "Shirdi to Pune One Way Cab",
"description": "Shirdi to Pune One Way Cab is a practical option for travelers needing direct transportation to Pune. Cab arrangements can be selected according to passenger count, luggage requirements, pickup timing, vehicle preference, and destination."
},
{
"name": "Shirdi to Pune Round Trip Cab",
"description": "Shirdi to Pune Round Trip Cab is suitable for travelers planning to visit Pune and return to Shirdi. The journey can be scheduled according to travel dates, stay duration, passenger count, vehicle category, waiting requirements, and preferred return itinerary."
},
{
"name": "Shirdi to Pune Ertiga Cab",
"description": "Shirdi to Pune Ertiga Cab provides spacious private transportation for families and small groups traveling to Pune. The Ertiga offers comfortable seating and luggage space and can be arranged for one-way, round-trip, airport, or customized travel plans."
},
{
"name": "Shirdi to Pune Innova Cab",
"description": "Shirdi to Pune Innova Cab is a spacious option for families and groups requiring comfortable seating and additional luggage capacity. The Innova can be arranged for direct travel, airport transfers, return journeys, business trips, and customized transportation requirements."
},
{
"name": "Shirdi to Pune Innova Crysta Cab",
"description": "Shirdi to Pune Innova Crysta Cab offers a premium and spacious travel option for families and groups traveling between Shirdi and Pune. The vehicle can be arranged for comfortable long-distance journeys, airport transfers, one-way trips, and return travel plans."
},
{
"name": "Shirdi to Pune Sedan Cab",
"description": "Shirdi to Pune Sedan Cab offers a practical private travel option for individuals, couples, and smaller families. Sedan vehicles can be arranged according to passenger count, luggage requirements, travel date, pickup location, and one-way or round-trip transportation needs."
},
{
"name": "Shirdi to Pune Airport Cab",
"description": "Shirdi to Pune Airport Cab provides convenient private airport transfer transportation for passengers traveling from Shirdi to Pune Airport. Travelers can select a suitable vehicle according to passenger count, luggage, flight schedule, pickup requirements, and destination."
},
{
"name": "Pune to Shirdi Taxi",
"description": "Pune to Shirdi Taxi provides private transportation for passengers traveling from Pune to Shirdi for pilgrimage, personal, or family trips. The taxi can be arranged according to the preferred pickup location, travel timing, passenger count, luggage requirements, and vehicle category."
},
{
"name": "Pune to Shirdi Cab",
"description": "Pune to Shirdi Cab offers convenient point-to-point transportation for travelers visiting Shirdi from Pune. Vehicle options can be selected according to passenger capacity, luggage space, pickup schedule, travel date, destination, and preferred one-way or return journey."
},
{
"name": "Pune to Shirdi Taxi Fare",
"description": "Pune to Shirdi Taxi Fare may depend on the selected vehicle category, journey type, pickup location, passenger count, route, and additional travel requirements. Travelers can request a suitable fare option for one-way, round-trip, or customized cab arrangements."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides private cab and taxi transportation for travelers between Shirdi, Pune, and other destinations. Suitable sedan, Ertiga, Innova, Innova Crysta, and other vehicle options can be arranged for local, pilgrimage, airport, railway station, and outstation travel requirements."
}
],
"tableData": [
["Shirdi to Pune Cabs", "Shirdi to Pune Cab"],
["Shirdi to Pune Taxi", "Shirdi to Pune Cab Service"],
["Shirdi to Pune Taxi Service", "Shirdi to Pune Cab Booking"],
["Shirdi to Pune Taxi Booking", "Shirdi to Pune Taxi Fare"],
["Shirdi to Pune Cab Fare", "Shirdi to Pune One Way Taxi"],
["Shirdi to Pune One Way Cab", "Shirdi to Pune Round Trip Cab"],
["Shirdi to Pune Ertiga Cab", "Shirdi to Pune Innova Cab"],
["Shirdi to Pune Innova Crysta Cab", "Shirdi to Pune Sedan Cab"],
["Shirdi to Pune Airport Cab", "Pune to Shirdi Taxi"],
["Pune to Shirdi Cab", "Pune to Shirdi Taxi Fare"],
["Sai Shirdi Cabs", "Shirdi to Pune Cabs"]
]
,















    whychoose: [
        { 
            WhyChooseheading: "Practical Shirdi to Pune Cabs for Comfortable Intercity Travel", 
            WhyChoosedescription: "Sai Shirdi Cabs offers private cab services from Shirdi to Pune for devotees, families, students, professionals, and tourists. Whether you are returning after Sai Baba Darshan or travelling onward for work or personal plans, a dedicated taxi provides convenient point-to-point transportation." 
        }, 
        { 
            WhyChooseheading: "Pickup from Hotels, Residences & Temple Area", 
            WhyChoosedescription: "Arrange your pickup from a hotel, residence, Sai Baba Temple surroundings, railway station area, or another convenient point in Shirdi. The departure can be coordinated according to your Darshan, hotel checkout, or onward travel schedule." 
        }, 
        { 
            WhyChooseheading: "Direct Cab Journey to Pune", 
            WhyChoosedescription: "Travel directly from Shirdi to your preferred location in Pune without changing vehicles. Private transportation is a convenient choice for passengers carrying luggage, travelling with children, or wanting a dedicated journey." 
        }, 
        { 
            WhyChooseheading: "Useful for Business & Personal Travel", 
            WhyChoosedescription: "Shirdi to Pune taxi service can be used for business meetings, office travel, family visits, educational requirements, airport connections, hotel transfers, and other personal or professional journeys." 
        }, 
        { 
            WhyChooseheading: "Comfortable Travel for Families & Groups", 
            WhyChoosedescription: "Families and small groups can choose a vehicle based on passenger numbers, luggage, and comfort preferences. Travelling together in one private cab makes coordination easier throughout the journey." 
        }, 
        { 
            WhyChooseheading: "One-Way Shirdi to Pune Cab Booking", 
            WhyChoosedescription: "Passengers who need only a drop from Shirdi to Pune can choose a one-way cab. This option is useful when you already have separate arrangements for your return journey or plan to continue travelling from Pune." 
        }, 
        { 
            WhyChooseheading: "Return Taxi for Shirdi & Pune Travel", 
            WhyChoosedescription: "Travellers who require transportation back to Shirdi can discuss a round-trip arrangement. The return schedule can be planned around your Pune work, family visit, sightseeing, or other activities." 
        }, 
        { 
            WhyChooseheading: "Book Shirdi to Pune Cabs with Sai Shirdi Cabs", 
            WhyChoosedescription: "Share your Shirdi pickup location, Pune destination, travel date, passenger count, luggage details, preferred vehicle, and one-way or return requirement with Sai Shirdi Cabs to arrange a suitable private cab." 
        } 
    ] 

}; 

const faqData = [ 
    { 
        question: "Can I book a cab from Shirdi to Pune?", 
        answer: "Yes, Sai Shirdi Cabs provides private cab services from Shirdi to Pune for devotees, families, tourists, professionals, and other travellers." 
    }, 
    { 
        question: "Can I get pickup from my hotel in Shirdi?", 
        answer: "Yes, passengers can arrange pickup from their Shirdi hotel, residence, temple area, railway station surroundings, or another convenient location." 
    }, 
    { 
        question: "Is Shirdi to Pune Cab suitable for family travel?", 
        answer: "Yes, families can select a suitable private vehicle according to their passenger count, luggage requirements, and preferred comfort level." 
    }, 
    { 
        question: "Do you provide one-way Shirdi to Pune Cab service?", 
        answer: "Yes, one-way cab service is available for passengers who require direct transportation from Shirdi to Pune without needing the same vehicle for the return journey." 
    }, 
    { 
        question: "Can I book a return cab from Pune to Shirdi?", 
        answer: "Yes, return transportation can be arranged for passengers who want to travel back to Shirdi after completing their work, family visit, business meeting, or other activities in Pune." 
    }, 
    { 
        question: "Which vehicles are available for Shirdi to Pune travel?", 
        answer: "Vehicle options may include sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and larger vehicles depending on passenger count, luggage, and travel requirements." 
    }, 
    { 
        question: "Can I book a taxi from Shirdi to Pune Airport?", 
        answer: "Yes, passengers can request a private cab from Shirdi to Pune Airport and provide their flight schedule so the pickup and journey can be planned accordingly." 
    }, 
    { 
        question: "Can senior citizens travel from Shirdi to Pune by cab?", 
        answer: "Yes, private cab travel is suitable for families travelling with senior citizens because everyone can remain together in a dedicated vehicle and manage the journey according to their schedule." 
    }, 
    { 
        question: "Can I carry luggage in the Shirdi to Pune taxi?", 
        answer: "Yes, passengers can carry luggage according to the storage capacity of the selected vehicle. Additional or bulky baggage should be mentioned during booking." 
    }, 
    { 
        question: "How can I book Shirdi to Pune Cabs with Sai Shirdi Cabs?", 
        answer: "Share your Shirdi pickup point, Pune destination, travel date, passenger details, luggage requirements, preferred vehicle, and one-way or return preference with Sai Shirdi Cabs to proceed with the cab booking." 
    } 
]; 

const testimonials = [ 
    { 
        id: 1, 
        name: "Mr. Prakash Jadhav", 
        feedback: "We booked a private cab from Shirdi to Pune after completing Sai Baba Darshan. Our family had several bags, so travelling directly in one vehicle was much more convenient than arranging multiple transport options.", 
        rating: 5 
    }, 
    { 
        id: 2, 
        name: "Mrs. Swati Deshmukh", 
        feedback: "Our journey from Shirdi to Pune was planned for a family visit. The private taxi was a comfortable option for our group, and having direct transportation made the overall travel arrangements much simpler.", 
        rating: 5 
    } 
];







    

    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shirdi to Pune Cabs",
  "image": "https://www.saishirdicabs.com/assets/images/shirdi-to-pune-cabs.webp",
  "description":
    "Book Shirdi to Pune Cabs with Sai Shirdi Cabs for a safe, comfortable, and reliable journey between Shirdi and Pune. We provide one-way, round-trip, and outstation taxi services for devotees, families, tourists, students, and business travelers. Choose from Sedan, Ertiga, Innova, Innova Crysta, and Tempo Traveller with professional drivers, comfortable vehicles, convenient pickup and drop facilities, flexible travel options, and affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/shirdi-to-pune-cabs"
  }
};





    return (
        <div>

<Helmet>
  <title>Shirdi to Pune Cabs | Shirdi to Pune Taxi Service | +91 7776814559</title>

  <meta
    name="description"
    content="Book Shirdi to Pune Cabs with Sai Shirdi Cabs for affordable one-way, round-trip and outstation taxi services. Hire Sedan, Ertiga, Innova, Innova Crysta and Tempo Traveller from Shirdi to Pune with professional drivers, comfortable travel, easy booking and convenient pickup and drop."
  />

  <meta
    name="keywords"
    content="Shirdi to Pune Cabs, Shirdi to Pune Cab, Shirdi to Pune Taxi, Shirdi to Pune cab service, Shirdi to Pune taxi service, Shirdi to Pune cab booking, Shirdi to Pune taxi booking, Shirdi to Pune taxi fare, Shirdi to Pune cab fare, Shirdi to Pune one way taxi, Shirdi to Pune one way cab, Shirdi to Pune round trip cab, Shirdi to Pune round trip taxi, Shirdi to Pune Ertiga Cab, Shirdi to Pune Innova Cab, Shirdi to Pune Innova Crysta Cab, Shirdi to Pune Sedan Cab, Shirdi to Pune Swift Dzire Cab, Shirdi to Pune Tempo Traveller, Shirdi to Pune Tempo Traveller on Rent, Shirdi to Pune Car Rental, Shirdi to Pune Car Hire, Shirdi to Pune Online Cab Booking, Shirdi to Pune Online Taxi Booking, Shirdi to Pune Cab Service, Shirdi to Pune Taxi Service, Shirdi Pune Cab, Shirdi Pune Taxi, Pune to Shirdi Cab, Pune to Shirdi Taxi, Pune to Shirdi Cab Service, Pune to Shirdi Taxi Service, Pune to Shirdi Cab Booking, Pune to Shirdi Taxi Booking, Pune to Shirdi One Way Cab, Pune to Shirdi One Way Taxi, Pune to Shirdi Round Trip Cab, Pune to Shirdi Round Trip Taxi, Affordable Shirdi to Pune Cab, Cheap Shirdi to Pune Taxi, Best Shirdi to Pune Cab Service, Reliable Shirdi to Pune Taxi, Shirdi to Pune Private Cab, Shirdi to Pune Family Cab, Shirdi to Pune Group Taxi, Shirdi to Pune Outstation Cab, Shirdi to Pune Outstation Taxi, Shirdi to Pune Travel Service, Shirdi to Pune Tour Taxi, Shirdi to Pune Pilgrimage Taxi, Shirdi to Pune Airport Cab, Shirdi to Pune Railway Station Taxi, Shirdi Pune Taxi Booking, Pune Shirdi Cab Booking, Sai Shirdi Cabs"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/48.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Shirditopunecab;